export default "__VITE_ASSET__Ckry1K_u__"